import { Text } from 'react-native';
import { FONT } from '../../../value/staticValues';

import { ReactComponent as WarningInfoImg } from "../../../img/ico-msg-warning-info.svg";
import { ReactComponent as MsgInfoImg } from "../../../img/ico-msg-info.svg";

interface AlertContentProps {
    text: string;
    size?: number;
    fontsize?: number;
    error?: boolean;
}

export default function AlertContent(props:AlertContentProps) {
    return (
        <div style={{
            visibility: props.text ? "visible" : "hidden",
            height: props.size || 16,
            display: "flex", flexDirection: "row", alignItems: "start",
        }}>
            {props.error ?
                <WarningInfoImg/>
            :
                <MsgInfoImg/>
            }
            <Text style={{
                marginLeft: 10, marginTop: 3,
                fontFamily: FONT.REGULAR,
                fontSize: props.fontsize || 12,
                lineHeight: 16,
                color: props.error ? "#db4d30" : "#323ebd"
            }}>
                {props.text}
            </Text>
        </div>
    )
}

export function AlertBoxContent(props:AlertContentProps) {
    return (
        <div style={{
            display: "flex", flexDirection: "row", alignItems: "center",
            visibility: props.text ? "visible" : "hidden",
            minWidth: 600, maxWidth: 930,
            height: 30, maxHeight: 30,
            paddingLeft: 15, paddingRight: 15,
            marginBottom: 15, marginLeft: -10,
            borderRadius: 15,
            backgroundColor: props.error ? "#fcf2f0" : "#f3f7ff"
        }}>
            {props.error ?
                <WarningInfoImg/>
            :
                <MsgInfoImg/>
            }
            <Text style={{
                marginLeft: 10, marginTop: 3,
                fontFamily: FONT.REGULAR,
                fontSize: props.fontsize || 12,
                lineHeight: 16,
                color: props.error ? "#db4d30" : "#323ebd"
            }}>
                {props.text}
            </Text>
        </div>
    )
}